import { ref } from 'vue';

export interface ExponentialBackoffOptions {
  baseMs?: number;
  factor?: number;
  maxRetries?: number;
}

export const useExponentialBackoff = ({
  baseMs = 1000,
  factor = 2,
  maxRetries = 5,
}: ExponentialBackoffOptions = {}) => {
  const failures = ref(0);

  const recordFailure = (): number | null => {
    failures.value += 1;
    if (failures.value > maxRetries) {
      return null;
    }
    return baseMs * factor ** (failures.value - 1);
  };

  const reset = () => {
    failures.value = 0;
  };

  return { failures, recordFailure, reset };
};
